module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "robofriends.b0f367bb.png" + "?" + Date.now();